export const mixin = {
  data() {
    return {
      page_size: 10,
      page_index: 1,
      total: 0,
    };
  },
  methods: {
    handleSizeChange(val) {
      this.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getList();
    },
    resetSearch() {
      this.searchParam = {};
    },
  },
};
